import React from 'react';
import { Switch, Route } from 'react-router-dom';

import {
  Home,
  AllClassrooms,
  AllEducators,
  Certificate,
  ResetPassword,
  ResetPasswordVerify,
  ClassroomView,
  Settings,
  EducatorRequest,
  EmailVerify,
  UserMe,
  ClassroomEdit,
  MyClassrooms,
  CreateClassroom,
  UserOther,
  UserMeEdit,
  NotFound,
  ClassroomMe,
} from './ChunkedComponents';

const routes = ({ auth }) => {
  return auth ? (
    <Switch>
      <Route exact path='/' component={Home} />
      <Route path='/all/classrooms' component={AllClassrooms} />
      <Route path='/certificate/:classroomId/:userId' component={Certificate} />
      <Route path='/classrooms/view/:id' component={ClassroomView} />
      <Route path='/all/educators' component={AllEducators} />
      <Route path='/reset/password/verify/:token' component={ResetPasswordVerify} />
      <Route path='/email/verify' component={EmailVerify} />
      <Route exact path='/user/me' component={UserMe} />
      <Route path='/user/me/classrooms' component={MyClassrooms} />
      <Route path='/user/me/request' component={EducatorRequest} />
      <Route path='/create/classroom' component={CreateClassroom} />
      <Route path='/user/me/settings' component={Settings} />
      <Route path='/user/other/:id' component={UserOther} />
      <Route path='/user/me/edit' component={UserMeEdit} />
      <Route path='/classrooms/edit/:id' component={ClassroomEdit} />
      <Route path='/classrooms/me/:id' component={ClassroomMe} />
      <Route component={NotFound} />
    </Switch>
  ) : (
    <Switch>
      <Route exact path='/' component={Home} />
      <Route path='/all/classrooms' component={AllClassrooms} />
      <Route path='/classrooms/view/:id' component={ClassroomView} />
      <Route path='/all/educators' component={AllEducators} />
      <Route exact path='/reset/password' component={ResetPassword} />
      <Route path='/reset/password/verify/:token' component={ResetPasswordVerify} />
      <Route path='/email/verify' component={EmailVerify} />
      <Route path='/user/other/:id' component={UserOther} />
      <Route path='/certificate/:classroomId/:userId' component={Certificate} />
      <Route component={NotFound} />
    </Switch>
  );
};

export default routes;
